// extracted by mini-css-extract-plugin
export default {"cls1":"slJhB1dbNP3uCMI9D4Jw","cls2":"liFe1vIvlU9uR9sBpg8T slJhB1dbNP3uCMI9D4Jw"};